<template>
  <div class="card">
    <div class="card-header">
      Contacts
    </div>
    <div class="p-6">
      <div class="text-gray-500">
        Select the contacts you'd like to send an email or SMS to whenever this automation rule is triggered.
      </div>
      <div class="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
        <div>
          <label class="form-label">SMS these contacts:</label>
          <contact-toggle :parent="form" type="cellphone" @toggle="methods.toggleContact" />
        </div>
        <div>
          <label class="form-label">Email these contacts:</label>
          <contact-toggle :parent="form" type="email" @toggle="methods.toggleContact" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactsCard',

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    }
  }
}
</script>